import 'angular';

import { PasswordControlComponent } from './password-control/password-control.component.ajs';
import { PasswordControlCtrl }      from './password-control/password-control.ajs';

angular.module('app-lite.core.controls', [])
.component('worPasswordControl', PasswordControlComponent)
.controller('PasswordControlCtrl', PasswordControlCtrl);
